import styled from 'styled-components';
import {
	// flexColumn, 
	flexRow
} from '../../../style/Global';
import {
    device
} from '../../../style/breakpoints';

export const IframeContainer = styled.div`
	display:flex;
	justify-content:center;
	@media ${device.tablet} {
		display:none;
	}
`

export const PlayerControlContainer = styled.div`
	${flexRow}
	justify-content: center;
`;

export const PlayerControlContainerCentered = styled.div`
	${flexRow}
	justify-content:center;
`;